import { Controller } from "@hotwired/stimulus"

/**
 * Simple dropdown toggle for the snooze button.
 *
 * data-controller="support--snooze-dropdown"
 */
export default class extends Controller {
  static targets = ["menu", "trigger"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  // Close on outside click
  connect() {
    this._handleClickOutside = (event) => {
      if (!this.element.contains(event.target)) {
        this.menuTarget.classList.add("hidden")
      }
    }
    document.addEventListener("click", this._handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._handleClickOutside)
  }
}
